import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';

/** Forms where the current user is a `Specific` sharing recipient. */
export function useAssignedForms(page: number, pageSize: number) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: FORM_KEYS.assignedToMe(orgId ?? '', page, pageSize),
    queryFn: ({ signal }) => formsService.getAssignedToMe(page, pageSize, signal),
    staleTime: 60_000,
    enabled: !!orgId,
    placeholderData: keepPreviousData,
  });

  return {
    forms: data?.data.items ?? [],
    pageInfo: data?.data,
    isLoading,
    isError,
  };
}
